// Smart translation utility that maintains UI consistency
export const smartTranslations = {
  en: {
    // Short translations for UI elements
    ui: {
      // Navigation & Actions
      back: "Back",
      next: "Next", 
      previous: "Prev",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      create: "Create",
      done: "Done",
      yes: "Yes",
      no: "No",
      ok: "OK",
      
      // Status & States
      loading: "Loading...",
      empty: "Empty",
      none: "None",
      all: "All",
      new: "New",
      old: "Old",
      
      // Time & Numbers
      today: "Today",
      yesterday: "Yesterday", 
      tomorrow: "Tomorrow",
      now: "Now",
      never: "Never",
      always: "Always",
      
      // Study related
      study: "Study",
      learn: "Learn",
      practice: "Practice",
      review: "Review",
      test: "Test",
      quiz: "Quiz",
      
      // Stats & Progress
      progress: "Progress",
      stats: "Stats",
      score: "Score",
      time: "Time",
      cards: "Cards",
      sets: "Sets",
      classes: "Classes",
      
      // Common UI elements
      settings: "Settings",
      profile: "Profile",
      home: "Home",
      menu: "Menu",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      refresh: "Refresh",
      
      // Buttons & Actions
      start: "Start",
      stop: "Stop",
      pause: "Pause",
      resume: "Resume",
      finish: "Finish",
      complete: "Complete",
      continue: "Continue",
      skip: "Skip",
      
      // Study session
      correct: "Right",
      wrong: "Wrong",
      easy: "Easy",
      hard: "Hard",
      again: "Again",
      
      // Additional UI elements
      streak: "Streak",
      time: "Study Time",
      document: "From Document",
      active: "Active",
      finished: "Finished",
      plays: "plays",
      success: "success",
      
      // Navigation
      home: "Home",
      classes: "Classes",
      sets: "Sets",
      flashcards: "Cards",
      study: "Study",
      profile: "Profile",
      settings: "Settings",
    }
  },
  
  fr: {
    // French translations with same/similar character count
    ui: {
      // Navigation & Actions (same length)
      back: "Retour",
      next: "Suivant", 
      previous: "Précédent",
      save: "Sauver",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      add: "Ajouter",
      create: "Créer",
      done: "Terminé",
      yes: "Oui",
      no: "Non",
      ok: "OK",
      
      // Status & States
      loading: "Chargement...",
      empty: "Vide",
      none: "Aucun",
      all: "Tous",
      new: "Nouveau",
      old: "Ancien",
      
      // Time & Numbers
      today: "Aujourd'hui",
      yesterday: "Hier", 
      tomorrow: "Demain",
      now: "Maintenant",
      never: "Jamais",
      always: "Toujours",
      
      // Study related
      study: "Étudier",
      learn: "Apprendre",
      practice: "Pratiquer",
      review: "Réviser",
      test: "Test",
      quiz: "Quiz",
      
      // Stats & Progress
      progress: "Progrès",
      stats: "Stats",
      score: "Score",
      time: "Temps",
      cards: "Cartes",
      sets: "Sets",
      classes: "Classes",
      
      // Common UI elements
      settings: "Paramètres",
      profile: "Profil",
      home: "Accueil",
      menu: "Menu",
      search: "Rechercher",
      filter: "Filtrer",
      sort: "Trier",
      refresh: "Actualiser",
      
      // Buttons & Actions
      start: "Commencer",
      stop: "Arrêter",
      pause: "Pause",
      resume: "Reprendre",
      finish: "Terminer",
      complete: "Compléter",
      continue: "Continuer",
      skip: "Passer",
      
      // Study session
      correct: "Correct",
      wrong: "Incorrect",
      easy: "Facile",
      hard: "Difficile",
      again: "Encore",
      
      // Additional UI elements
      streak: "Série",
      time: "Temps Étude",
      document: "Depuis Doc",
      active: "Actif",
      finished: "Terminé",
      plays: "parties",
      success: "succès",
      
      // Navigation
      home: "Accueil",
      classes: "Cours",
      sets: "Sets",
      flashcards: "Cartes",
      study: "Étude",
      profile: "Profil",
      settings: "Paramètres",
    }
  }
};

// Smart translation function that uses UI-optimized translations
export const getSmartTranslation = (language, key) => {
  const translations = smartTranslations[language] || smartTranslations.en;
  return translations.ui[key] || key;
};

// Character count utilities
export const getCharacterCount = (text) => {
  return text.length;
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
};

// UI-safe translation function
export const getUISafeTranslation = (language, key, maxLength = 20) => {
  const translation = getSmartTranslation(language, key);
  return truncateText(translation, maxLength);
};